/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, teamId, context } = {}) {
    const params = {};
    if (searchKey) params.search = searchKey;
    if (teamId) params.team_id = teamId;
    if (context) params.context = context;
    return axios.get(this.url, { params });
  }

  specialties() {
    return axios.get(`${this.url}/specialties`);
  }
}

export default new CannedResponse();
